import { useI18n } from 'vue-i18n';
import { AbstractFilter } from './abstractFilter';

export class RangeFilter extends AbstractFilter {
  getDisplayName(filterValue = {}) {
    const { t } = useI18n();
    const { value } = filterValue;
    const { type, fromValue, toValue, value: rangeValue, name } = value || {};
    if (!type || !(value || fromValue || toValue)) return '';
    const nValue = ` ${rangeValue || ''}${fromValue || ''}${toValue ? ` to ${toValue}` : ''}`;
    return ` \n${t(name || type)} ${nValue.trim()}`;
  }
}
